import { render, staticRenderFns } from "./edit-stakeholder-group.vue?vue&type=template&id=5de8bc0a"
import script from "./edit-stakeholder-group.ts?vue&type=script&lang=js&external"
export * from "./edit-stakeholder-group.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports